import {PUBLIC_ID_CAPTURE, SIGN_IN_ROUTE, SLUG_CAPTURE} from '../../../shared/constants/routes';
import {__REDIRECT__} from '../../../shared/enhancers/router-enhancer';

const plan = (match, {canEdit, hasOwner}) => {
  if (canEdit && hasOwner) {
    return {
      slug: match[1],
      showPlan: true
    };
  } else {
    return {
      [__REDIRECT__]: `/${match[1]}`
    };
  }
};

const planSuccess = (match, {canEdit, hasOwner}) => {
  if (canEdit && hasOwner) {
    return {
      slug: match[1],
      showPlan: true,
      planSuccess: true
    };
  } else {
    return {
      [__REDIRECT__]: `/${match[1]}`
    };
  }
};

const slug = match => ({
  slug: match[1]
});

export const routes = {
  [SIGN_IN_ROUTE]: (match, props, prevRouteContext) => ({
    ...prevRouteContext,
    signin: true
  }),
  [`/${SLUG_CAPTURE}/decisions/${PUBLIC_ID_CAPTURE}$`]: (match, props, prevRouteContext) => ({
    ...prevRouteContext,
    decision: {userSlug: match[1].toLowerCase(), id: match[2]}
  }),
  [`^/companies/${SLUG_CAPTURE}/plan/success$`]: planSuccess,
  [`^/companies/${SLUG_CAPTURE}/plan$`]: plan,
  [`^/companies/${SLUG_CAPTURE}/slack-install$`]: match => ({
    slug: match[1],
    slackInstall: true
  }),
  [`^/companies/${SLUG_CAPTURE}$`]: slug,
  [`^/${SLUG_CAPTURE}/plan/success$`]: planSuccess,
  [`^/${SLUG_CAPTURE}/plan$`]: plan,
  [`^/${SLUG_CAPTURE}$`]: slug,
  [`^/${SLUG_CAPTURE}/stacks$`]: slug
};
